import { TrackingEventCategories as BaseTrackingEventCategories } from '../../common/tracking/tracking-event-categories.model';

export const TrackingEventCategories = {
  ...BaseTrackingEventCategories,
  TAB_TANKS_ACTION: 'tab_tanks_actions',
  TAB_MODBUS_REQUEST_TABLE_ACTION: 'tab_modbus_request_table_actions'
};
